import { presentLexError } from '@/lib/user-notice';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { apiFetch } from '@/lib/api';

const primaryBlue = '#1976D2';

export function RegisterPage() {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!fullName.trim() || !email.trim()) {
      setError('Nombre completo y correo son obligatorios.');
      return;
    }
    setSubmitting(true);
    try {
      const res = await apiFetch('/api/auth/register-lex', {
        method: 'POST',
        body: JSON.stringify({ fullName: fullName.trim(), email: email.trim().toLowerCase() }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setError((data as { error?: string }).error || 'Error al registrar.');
        return;
      }
      setSuccess(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error de conexión.');
    } finally {
      setSubmitting(false);
    }
  };

  if (success) {
    return (
      <main className="lex-auth-shell" style={{ flexDirection: 'column', background: 'var(--lex-background)' }}>
        <div
          style={{
            background: primaryBlue,
            color: '#fff',
            padding: '24px 32px',
            borderRadius: 16,
            marginBottom: 24,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 8,
          }}
        >
          <i className="ri-scales-3-fill" style={{ fontSize: 40 }} aria-hidden />
          <span style={{ fontSize: 28, fontWeight: 800 }}>DUMAS</span>
          <span style={{ fontSize: 14, opacity: 0.95 }}>by DU+</span>
        </div>
        <p style={{ textAlign: 'center', margin: '0 0 12px', fontSize: 18, fontWeight: 600, color: 'var(--lex-on-surface)' }}>
          Registro exitoso
        </p>
        <p style={{ textAlign: 'center', margin: 0, fontSize: 14, color: 'var(--lex-on-surface-variant)', maxWidth: 320 }}>
          Revisa tu correo para obtener tus credenciales de acceso.
        </p>
        <Link to="/login" style={{ marginTop: 24, color: primaryBlue, fontWeight: 600, fontSize: 14 }}>
          Ir a iniciar sesión
        </Link>
      </main>
    );
  }

  return (
    <main className="lex-auth-shell" style={{ flexDirection: 'column', background: 'var(--lex-background)' }}>
      <div
        style={{
          background: primaryBlue,
          color: '#fff',
          padding: '24px 32px',
          borderRadius: 16,
          marginBottom: 24,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <i className="ri-scales-3-fill" style={{ fontSize: 40 }} aria-hidden />
        <span style={{ fontSize: 28, fontWeight: 800 }}>Lex</span>
        <span style={{ fontSize: 14, opacity: 0.95 }}>by DU+</span>
      </div>

      <p style={{ margin: '0 0 20px', fontSize: 16, fontWeight: 600, color: 'var(--lex-on-surface)' }}>Registrarse</p>

      <form
        onSubmit={handleSubmit}
        style={{
          width: '100%',
          maxWidth: 320,
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
        }}
      >
        <div>
          <label htmlFor="fullName" style={{ display: 'block', marginBottom: 4, fontSize: 14, fontWeight: 500 }}>
            Nombre completo
          </label>
          <input
            id="fullName"
            type="text"
            autoComplete="name"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            disabled={submitting}
            style={{
              width: '100%',
              padding: '10px 12px',
              fontSize: 16,
              border: '1px solid var(--lex-outline)',
              borderRadius: 8,
            }}
          />
        </div>
        <div>
          <label htmlFor="email" style={{ display: 'block', marginBottom: 4, fontSize: 14, fontWeight: 500 }}>
            Correo electrónico
          </label>
          <input
            id="email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={submitting}
            style={{
              width: '100%',
              padding: '10px 12px',
              fontSize: 16,
              border: '1px solid var(--lex-outline)',
              borderRadius: 8,
            }}
          />
        </div>
        {error ? <p style={{ margin: 0, color: '#c00', fontSize: 14 }}>{presentLexError(error)}</p> : null}
        <button
          type="submit"
          disabled={submitting}
          style={{
            padding: '12px 24px',
            background: primaryBlue,
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            fontWeight: 600,
            fontSize: 16,
            cursor: submitting ? 'wait' : 'pointer',
          }}
        >
          {submitting ? 'Enviando…' : 'Registrarme'}
        </button>
      </form>

      <Link to="/login" style={{ marginTop: 20, color: primaryBlue, fontSize: 14 }}>
        Ya tengo cuenta — Iniciar sesión
      </Link>
    </main>
  );
}
